export const offices = [
  {
    city: "Albany, NY",
    locationKey: "Albany",
    address: "12 Corporate Woods Boulevard, Suite 410\nAlbany, NY 12211",
    phone: "(838) 221-3600",
    fax: "(838) 234-0515",
  },
  {
    city: "Atlantic City, NJ",
    locationKey: "Atlantic City",
    address: "1008 South New Road\nPleasantville, NJ 08232",
    phone: "(609) 383-2300",
    fax: "(609) 383-8333",
  },
  {
    city: "Baltimore, MD",
    locationKey: "Baltimore",
    address: "100 International Drive, 23rd Floor\nBaltimore, MD 21202",
    phone: "(443) 759-3827",
    fax: "(443) 759-3512",
  },
  {
    city: "Buffalo, NY",
    locationKey: "Buffalo",
    address: "500 Corporate Parkway, Suite 108\nAmherst, NY 14226",
    phone: "(680) 697-8860",
  },
  {
    city: "Harrisburg, PA",
    locationKey: "Harrisburg",
    address: "120 State Street\nHarrisburg, PA 17101",
    phone: "(717) 980-3700",
    fax: "(717) 983-0611",
  },
  {
    city: "Marlton, NJ",
    locationKey: "Marlton",
    address: "5 Greentree Centre, Suite 310\n525 Route 73 North\nMarlton, NJ 08053",
    phone: "(856) 316-0511",
    fax: "(215) 665-8300",
  },
  {
    city: "New Brunswick, NJ",
    locationKey: "New Brunswick",
    address: "317 George Street, 3rd Floor\nNew Brunswick, NJ 08901",
    phone: "(732) 884-2300",
    fax: "(848) 305-6002",
  },
  {
    city: "New York, NY",
    locationKey: "New York",
    address: "229 West 36th Street, 8th Floor\nNew York, NY 10018",
    phone: "(212) 377-5229",
    fax: "(215) 665-8300",
  },
  {
    city: "Palm Beach, FL",
    locationKey: "Palm Beach",
    address: "11631 Kew Gardens Avenue, Suite 200\nPalm Beach Gardens, FL 33410",
    phone: "(561) 624-1051",
    fax: "(561) 624-7441",
  },
  {
    city: "Philadelphia, PA",
    locationKey: "Philadelphia",
    address: "Two Logan Square, Suite 700\n100 North 18th Street\nPhiladelphia, PA 19103",
    phone: "(215) 569-2400",
    fax: "(215) 665-8300",
  },
  {
    city: "Pittsburgh, PA",
    locationKey: "Pittsburgh",
    address: "301 Grant Street, Suite 270\nPittsburgh, PA 15219",
    phone: "(412) 392-7510",
  },
  {
    city: "Sarasota, FL",
    locationKey: "Sarasota",
    address: "5589 Marquesas Circle, Suite 101\nSarasota, FL 34233",
    phone: "(941) 328-6200",
    fax: "(941) 328-6211",
  },
  {
    city: "Syracuse, NY",
    locationKey: "Syracuse",
    address: "126 North Salina Street, Suite 210\nSyracuse, NY 13202",
    phone: "(680) 697-8860",
    fax: "(680) 212-0211",
  },
  {
    city: "Tampa, FL",
    locationKey: "Tampa",
    address: "100 S. Ashley Drive, Suite 600\nTampa, FL 33602",
    phone: "(561) 624-1051",
    fax: "(561) 624-7441",
  },
  {
    city: "Wilmington, DE",
    locationKey: "Wilmington",
    address: "1523 Concord Pike, Suite 200\nWilmington, DE 19803",
    phone: "(302) 493-0569",
    fax: "(302) 777-4111",
  },
];
